<div [formGroup]="parentForm">
  <div class="da-card">
    <h3 class="card-title">Education</h3>

    <div formArrayName="education">
      <div *ngFor="let edu of education.controls; let i=index" [formGroupName]="i" class="edu-item">
        <div class="card-header-actions">
          <div class="title">{{ edu.get('grade')?.value | uppercase }}</div>
          <div class="actions">
            <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-text"
              style="color: #ef4444; background: transparent; border: none; font-size: 1.2rem; cursor: pointer;"
              (click)="removeEducation(i)"></button>
          </div>
        </div>

        <!-- Level Selector: show only for new entries without a level set -->
        <div class="field-group" *ngIf="edu.get('level')?.value === null || edu.get('level')?.value === undefined">
          <label>Select Education Level <span class="required">*</span></label>
          <p-dropdown
            formControlName="level"
            [options]="availableLevelOptions"
            appendTo="body"
            placeholder="e.g. Grade 10, Grade 12, Bachelors..."
            [style]="{'width':'100%'}"
            [class.ng-invalid]="isFieldInvalid(edu, 'level')"
            [class.ng-dirty]="isFieldInvalid(edu, 'level')">
          </p-dropdown>
          <app-field-error [control]="edu.get('level')" type="requiredOnly" fieldName="Education Level"></app-field-error>
        </div>

        <!-- All remaining content: only show after level is selected -->
        <ng-container *ngIf="edu.get('level')?.value !== null && edu.get('level')?.value !== undefined">

        <div class="file-upload-row" [class.has-file]="edu.get('fileUrl')?.value">
          <ng-container *ngIf="edu.get('fileUrl')?.value; else noEduFile">
            <div class="uploaded-file-pill">
              <img src="assets/doc-icon.png" class="doc-icon" alt="Document">
              <div class="file-details">
                <div class="file-name-row">
                  <span class="file-name" (click)="previewFile(edu.get('fileUrl')?.value, (edu.get('grade')?.value + ' Marksheet'))">
                    {{ edu.get('grade')?.value + ' Marksheet.pdf' }}
                  </span>
                  <i class="pi pi-check-circle check-icon" style="color: #16a34a;"></i>
                </div>
                <div class="file-meta">Uploaded &middot; autofilled below</div>
              </div>
              <input type="file" #eduReplaceInput style="display:none" accept=".pdf,.doc,.docx" (change)="onFileSelected($event, i, eduReplaceInput)">
              <button type="button" class="replace-btn" title="Replace" (click)="eduReplaceInput.click()">Replace</button>
            </div>
          </ng-container>
          <ng-template #noEduFile>
            <div class="uploaded-file-pill" style="opacity: 0.6;">
              <img src="assets/doc-icon.png" class="doc-icon" alt="Document">
              <div class="file-details">
                <div class="file-name-row">
                  <span class="file-name" style="color: #9ca3af;">{{ edu.get('grade')?.value + ' Marksheet' }} — Not uploaded</span>
                </div>
                <div class="file-meta" style="color: #f97316;"><i class="pi pi-upload" style="font-size: 11px;"></i> No file yet</div>
              </div>
              <input type="file" #eduUploadInput style="display:none" accept=".pdf,.doc,.docx" (change)="onFileSelected($event, i, eduUploadInput)">
              <button class="replace-btn" (click)="eduUploadInput.click()">Upload</button>
            </div>
          </ng-template>
        </div>
        <app-field-error [control]="edu.get('fileUrl')" type="requiredOnly" fieldName="Document" style="margin-bottom: 16px; display: block;"></app-field-error>

        <div class="form-grid">
          <ng-container *ngIf="edu.get('level')?.value !== 3 && edu.get('level')?.value !== 4; else bachelorsView">

            <!-- School Name -->
            <div class="field-group">
              <label>School Name <span class="required">*</span></label>
              <input pInputText formControlName="schoolName" placeholder="e.g. DAV Public School"
                [class.ng-invalid]="isFieldInvalid(edu, 'schoolName')"
                [class.ng-dirty]="isFieldInvalid(edu, 'schoolName')" />
              <app-field-error [control]="edu.get('schoolName')" type="schoolName" fieldName="School Name"></app-field-error>
            </div>

            <!-- Location: City (text) + Country (dropdown) -->
            <div class="field-group">
              <label>Location (City, Country) <span class="required">*</span></label>
              <div class="location-split-row">
                <div style="flex: 1;">
                  <input pInputText formControlName="city" placeholder="City" class="city-input"
                    [class.ng-invalid]="isFieldInvalid(edu, 'city')"
                    [class.ng-dirty]="isFieldInvalid(edu, 'city')" />
                  <app-field-error [control]="edu.get('city')" type="cityName" fieldName="City"></app-field-error>
                </div>
                <div style="flex: 1;">
                  <p-dropdown
                    formControlName="country"
                    [options]="countryOptions"
                    placeholder="Country"
                    [filter]="true"
                    filterPlaceholder="Search country..."
                    appendTo="body"
                    [style]="{'width':'100%'}"
                    class="country-dropdown"
                    [class.ng-invalid]="isFieldInvalid(edu, 'country')"
                    [class.ng-dirty]="isFieldInvalid(edu, 'country')">
                  </p-dropdown>
                  <app-field-error [control]="edu.get('country')" type="requiredOnly" fieldName="Country"></app-field-error>
                </div>
              </div>
            </div>

            <!-- Years Attended -->
            <div class="field-group">
              <label>Years Attended <span class="required">*</span></label>
              <div class="flex-row gap-12" style="display: flex; gap: 12px; align-items: flex-start;">
                <div style="width: 50%">
                  <input pInputText formControlName="yearsFrom" placeholder="From (e.g. 2022)" maxlength="4" oninput="this.value = this.value.replace(/[^0-9]/g, '')" style="width: 100%"
                    [class.ng-invalid]="isFieldInvalid(edu, 'yearsFrom')"
                    [class.ng-dirty]="isFieldInvalid(edu, 'yearsFrom')" />
                  <app-field-error [control]="edu.get('yearsFrom')" type="yearField" fieldName="From year"></app-field-error>
                </div>
                <div style="width: 50%">
                  <input pInputText formControlName="yearsTo" placeholder="To (e.g. 2024)" maxlength="4" oninput="this.value = this.value.replace(/[^0-9]/g, '')" style="width: 100%"
                    [class.ng-invalid]="isFieldInvalid(edu, 'yearsTo')"
                    [class.ng-dirty]="isFieldInvalid(edu, 'yearsTo')" />
                  <app-field-error [control]="edu.get('yearsTo')" type="yearField" fieldName="To year"></app-field-error>
                </div>
              </div>
            </div>

            <!-- Board / Exam Type: Dropdown -->
            <div class="field-group">
              <label>Board / Exam Type <span class="required">*</span></label>
              <p-dropdown
                formControlName="boardId"
                [options]="boardOptions"
                placeholder="Select Board / Exam Type"
                [filter]="true"
                filterPlaceholder="Search..."
                appendTo="body"
                [style]="{'width':'100%'}"
                [class.ng-invalid]="isFieldInvalid(edu, 'boardId')"
                [class.ng-dirty]="isFieldInvalid(edu, 'boardId')">
              </p-dropdown>
              <app-field-error [control]="edu.get('boardId')" type="requiredOnly" fieldName="Board / Exam Type"></app-field-error>
            </div>

            <!-- Subjects & Grades / Scores and Grade/Percentage in same 2-col row -->
            <div class="field-group">
              <label>Subjects &amp; Grades / Scores <span class="required">*</span></label>

              <!-- Inline: name input + score input + add button -->
              <div class="subject-add-row" style="position: relative; display: flex; gap: 8px;">
                <div style="flex: 1;">
                  <input
                    pInputText
                    [(ngModel)]="subjectInputs[i]"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="Subject name"
                    class="subject-name-input"
                    [class.ng-invalid]="!isSubjectValid(i)"
                    [class.ng-dirty]="!isSubjectValid(i)"
                    (keydown.enter)="addSubjectTag(i)" style="width: 100%; height:42px" />
                  <div class="error-msg" *ngIf="!isSubjectValid(i)" style="position: absolute;">
                    <span>invalid format</span>
                  </div>
                </div>
                <div style="width: 100px;">
                  <input
                    pInputText
                    [(ngModel)]="scoreInputs[i]"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="Score"
                    class="score-input"
                    [class.ng-invalid]="!isScoreValid(i)"
                    [class.ng-dirty]="!isScoreValid(i)"
                    (keydown.enter)="addSubjectTag(i)" style="width: 100%; height:42px" />
                  <div class="error-msg" *ngIf="!isScoreValid(i)" style="position: absolute;">
                    <span>invalid format</span>
                  </div>
                </div>
                <button
                  pButton
                  type="button"
                  icon="pi pi-plus"
                  class="p-button-primary add-subject-btn"
                  [disabled]="!canAddSubject(i)"
                  style="background:#000086; border:none; border-radius:8px; color:white; cursor:pointer; min-width:36px; height:42px; display:flex; align-items:center; justify-content:center;"
                  (click)="addSubjectTag(i)">
                </button>
              </div>

              <div class="subject-tags-wrap" *ngIf="subjectTags[i]?.length" style="margin-top: 10px;">
                <span class="subject-tag" *ngFor="let tag of subjectTags[i]; let ti=index">
                  {{ tag.name }}<ng-container *ngIf="tag.score"> — {{ tag.score }}</ng-container>
                  <button type="button" class="tag-remove-btn" (click)="removeSubjectTag(i, ti)">×</button>
                </span>
              </div>
              <div class="error-msg" *ngIf="(!subjectTags[i] || subjectTags[i].length === 0) && edu.touched">
                <span>At least one Subject &amp; Grade is required</span>
              </div>
            </div>

            <!-- Grade / Percentage -->
            <div class="field-group">
              <label>Grade / Percentage <span class="required">*</span></label>
              <input pInputText formControlName="percentage" placeholder="e.g. 87"
                style="height: 42px;"
                [class.ng-invalid]="isFieldInvalid(edu, 'percentage')"
                [class.ng-dirty]="isFieldInvalid(edu, 'percentage')" />
              <app-field-error [control]="edu.get('percentage')" type="percentageScore" fieldName="Grade / Percentage"></app-field-error>
            </div>

          </ng-container>

          <!-- Bachelors / Masters view -->
          <ng-template #bachelorsView>
            <div class="field-group">
              <label>University Name <span class="required">*</span></label>
              <input pInputText formControlName="universityName"
                placeholder="Enter university name"
                [class.ng-invalid]="isFieldInvalid(edu, 'universityName')"
                [class.ng-dirty]="isFieldInvalid(edu, 'universityName')" />
              <app-field-error [control]="edu.get('universityName')" type="personName" fieldName="University Name"></app-field-error>
            </div>

            <div class="field-group">
              <label>Degree Name <span class="required">*</span></label>
              <input pInputText formControlName="degreeName"
                placeholder="Enter degree title"
                [class.ng-invalid]="isFieldInvalid(edu, 'degreeName')"
                [class.ng-dirty]="isFieldInvalid(edu, 'degreeName')" />
              <app-field-error [control]="edu.get('degreeName')" type="personName" fieldName="Degree Name"></app-field-error>
            </div>

            <!-- Location: City + Country -->
            <div class="field-group">
              <label>Location (City, Country) <span class="required">*</span></label>
              <div class="location-split-row">
                <div style="flex: 1;">
                  <input pInputText formControlName="city" placeholder="City" class="city-input"
                    [class.ng-invalid]="isFieldInvalid(edu, 'city')"
                    [class.ng-dirty]="isFieldInvalid(edu, 'city')" />
                  <app-field-error [control]="edu.get('city')" type="cityName" fieldName="City"></app-field-error>
                </div>
                <div style="flex: 1;">
                  <p-dropdown
                    formControlName="country"
                    [options]="countryOptions"
                    placeholder="Country"
                    [filter]="true"
                    filterPlaceholder="Search country..."
                    appendTo="body"
                    [style]="{'width':'100%'}"
                    class="country-dropdown"
                    [class.ng-invalid]="isFieldInvalid(edu, 'country')"
                    [class.ng-dirty]="isFieldInvalid(edu, 'country')">
                  </p-dropdown>
                  <app-field-error [control]="edu.get('country')" type="requiredOnly" fieldName="Country"></app-field-error>
                </div>
              </div>
            </div>

            <div class="field-group">
              <label>Years Attended <span class="required">*</span></label>
              <div class="flex-row gap-12" style="display: flex; gap: 12px; align-items: flex-start;">
                <div style="width: 50%">
                  <input pInputText formControlName="yearsFrom" placeholder="From" style="width: 100%"
                    [class.ng-invalid]="isFieldInvalid(edu, 'yearsFrom')"
                    [class.ng-dirty]="isFieldInvalid(edu, 'yearsFrom')" />
                    <app-field-error [control]="edu.get('yearsFrom')" type="yearField" fieldName="From year"></app-field-error>
                </div>
                <div style="width: 50%">
                  <input pInputText formControlName="yearsTo" placeholder="To" style="width: 100%"
                    [class.ng-invalid]="isFieldInvalid(edu, 'yearsTo')"
                    [class.ng-dirty]="isFieldInvalid(edu, 'yearsTo')" />
                    <app-field-error [control]="edu.get('yearsTo')" type="yearField" fieldName="To year"></app-field-error>
                </div>
              </div>
            </div>

            <div class="field-group">
              <label>Majors <span class="required">*</span></label>
              <input pInputText formControlName="majors"
                placeholder="Enter major subjects"
                [class.ng-invalid]="isFieldInvalid(edu, 'majors')"
                [class.ng-dirty]="isFieldInvalid(edu, 'majors')" />
              <app-field-error [control]="edu.get('majors')" type="personName" fieldName="Majors"></app-field-error>
            </div>

          </ng-template>
        </div>

        <div style="display: flex; justify-content: flex-end; margin-top: 1rem;">
          <button pButton type="button"
                  [label]="edu.get('id')?.value ? 'Update' : 'Save'"
                  icon="pi pi-check"
                  [loading]="isSavingMap[i]"
                  [disabled]="isSavingMap[i]"
                  style="background: #000086; color: white; border: none; border-radius: 8px; padding: 0.5rem 1.5rem; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 0.5rem;"
                  (click)="saveEducation(i)">
          </button>
        </div>
        <div class="unsaved-warning" *ngIf="edu.dirty">
          You have unsaved changes. Please click {{ edu.get('id')?.value ? 'Update' : 'Save' }} to continue.
        </div>

        </ng-container> <!-- end level-selected ng-container -->

      </div>
    </div>

    <div class="add-item-trigger" *ngIf="!allLevelsAdded" (click)="addEducation()">
      <button class="btn-link">+ Add Another Education</button>
    </div>
  </div>

  <!-- PDF Preview Dialog -->
  <p-dialog [(visible)]="displayPreviewDialog" [modal]="true" [header]="previewFileName" [dismissableMask]="true"
    [style]="{width: 'auto', 'max-width': '90vw', 'min-width': '60vw'}">
    <div class="preview-dialog-body" style="padding: 0;">
      <iframe *ngIf="safePdfUrl" [src]="safePdfUrl" width="100%" height="650px" style="border: none; display: block;" allowfullscreen></iframe>
      <div style="text-align: center; padding: 8px;">
        <a [href]="originalFileUrl" target="_blank" style="font-size: 13px; color: #1A237E;">
          <i class="pi pi-download"></i> Open / Download directly
        </a>
      </div>
    </div>
  </p-dialog>

  <p-toast></p-toast>

  <!-- Custom Delete Confirmation Dialog -->
  <p-dialog
    [(visible)]="showDeleteDialog"
    [modal]="true"
    [closable]="!isDeleting"
    [dismissableMask]="!isDeleting"
    [style]="{width: '450px'}"
    styleClass="custom-delete-dialog"
    header="Delete Confirmation">
    <div style="display:flex; align-items:center; gap:16px; justify-content:center; padding: 0.5rem 0;">
      <span style="background:#eef2ff; border-radius:50%; width:60px; height:60px; display:inline-flex; align-items:center; justify-content:center; flex-shrink:0;">
        <i class="pi pi-exclamation-triangle" style="font-size:28px; color:#0b0a66;"></i>
      </span>
      <span style="font-size:17px; font-weight:600; color:#000; line-height:1.5;">Are you sure you want to delete this education record?</span>
    </div>
    <ng-template pTemplate="footer">
      <button pButton
        class="custom-confirm-no"
        label="No"
        icon="pi pi-times"
        (click)="cancelDelete()"
        [disabled]="isDeleting">
      </button>
      <button pButton
        class="custom-confirm-yes"
        [label]="isDeleting ? 'Deleting...' : 'Yes'"
        [icon]="isDeleting ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
        (click)="confirmDelete()"
        [disabled]="isDeleting">
      </button>
    </ng-template>
  </p-dialog>

<!-- Document-reading modal -->
<app-linkdindetails-fetch
  *ngIf="isDocModalVisible"
  [isVisible]="isDocModalVisible"
  [autoComplete]="false"
  (onComplete)="onDocModalComplete()"
  (onCancel)="onDocModalCancel()"
  (onClose)="onDocModalClose()">
</app-linkdindetails-fetch>

</div>